import { useDispatch, useSelector } from 'react-redux'
import { setOpcion, claveActual } from '../../../redux/slices/perfil'

type Props = {
  titulo: string
  descripcion: string
  clave: string
  icon: string
}
const OPCION_ACTIVA = 'bg-light-primary text-primary'

export const OpcionMenu = ({ titulo, descripcion, clave, icon }: Props) => {
  const dispatch = useDispatch()
  const opcion = useSelector(claveActual)
  const opcSeleccionada = clave === opcion

  return (
    <div
      className={`card-rounded bg-hover-light text-hover-inverse-light d-flex flex-stack px-4 py-2 ${
        opcSeleccionada ? OPCION_ACTIVA : ''
      }`}
      onClick={() => {
        dispatch(setOpcion(clave))
      }}>
      <div className='symbol symbol-35px me-4 '>
        <div
          className={`symbol-label fs-2 fw-semibold ${
            opcSeleccionada ? 'bg-primary text-white' : ''
          }' : ''}`}>
          <i className={`${icon} ${opcSeleccionada ? ' text-white' : ''}`}></i>
        </div>
      </div>
      <div className='d-flex align-items-center flex-row-fluid'>
        <div className='flex-grow-1 me-2'>
          <div className='text-gray-800 text-hover-primary fs-6 fw-bold'>{titulo}</div>

          <span className='text-muted fw-semibold d-block fs-7 text-break'>{descripcion}</span>
        </div>
        <div>
          <button
            className={`btn btn-icon ${
              opcSeleccionada ? 'btn-primary' : 'btn-bg-light'
            } w-20px h-20px`}
            onClick={() => {
              dispatch(setOpcion(clave))
            }}>
            <i className='fa-sharp fa-solid fa-chevron-right fa-1x'></i>
          </button>
        </div>
      </div>
    </div>
  )
}
